function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M35,46H3c-0.6,0-1-0.4-1-1V13.5c0-0.3,0.1-0.5,0.3-0.7l9.5-9.5C12,3.1,12.3,3,12.5,3H35c0.6,0,1,0.4,1,1v13.1 c0,0.6-0.4,1-1,1s-1-0.4-1-1V5H12.9L4,13.9V44h30v-5.1c0-0.6,0.4-1,1-1s1,0.4,1,1V45C36,45.6,35.6,46,35,46z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M35,37c-5,0-9-4-9-9c0-5,4-9,9-9s9,4,9,9C44,33,40,37,35,37z M35,21c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7s7-3.1,7-7 C42,24.1,38.9,21,35,21z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M46.5,40.5c-0.3,0-0.5-0.1-0.7-0.3L40,34.5c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5.8,5.8c0.4,0.4,0.4,1,0,1.4 C47,40.4,46.8,40.5,46.5,40.5z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.5,34.1h-12c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.6,0,1,0.4,1,1S22.1,34.1,21.5,34.1z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.5,27.6h-12c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.6,0,1,0.4,1,1S22.1,27.6,21.5,27.6z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.5,21.1h-12c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.6,0,1,0.4,1,1S22.1,21.1,21.5,21.1z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.5,14.5H3c-0.4,0-0.8-0.2-0.9-0.6c-0.2-0.4-0.1-0.8,0.2-1.1l9.5-9.5c0.3-0.3,0.7-0.4,1.1-0.2c0.4,0.2,0.6,0.5,0.6,0.9 v9.5C13.5,14.1,13.1,14.5,12.5,14.5z M5.4,12.5h6.1V6.4L5.4,12.5z"
}));

function SvgDocumentSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document-search_svg__document-search_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgDocumentSearch;